import React from "react";

const Subtitle2 = ({ content }) => {
  return (
    <div className="articleRender-container subtitle2Block">{content.text}</div>
  );
};

export default Subtitle2;
